export default __webpack_public_path__ + "static/media/Classwin-aspect-ratio-four-to-three-focus.775f814c.svg";